import envDetect from '@tcc/env-detect';
import { isImpersonating, isProxyingItself } from './isImpersonating';
import { ROUTE } from '../constants/routes';

// TODO DASHBOARD DOES NOT HAVE SELECTOR AS WELL

function hideByUrl(route: string): boolean {
  return route === ROUTE.Connect;
}

/**
 * Determines whether to show opertions; only show if user is not proxying or on Salesforce or on
 * a web app only meant for single-operation use - this excludes Settings and DMB
 * @param {Object} user
 * @param {String} route
 * @return {Boolean}
 */
export function shouldShowOperationSelector({user, route}) {
  const onSalesforce = envDetect.isSalesforce();
  if (hideByUrl(route) || onSalesforce) {
    return false;
  }

  return (!isImpersonating(user) && !isProxyingItself(user));
}
